import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Сохранить доли крипто-активов портфеля: [{ coin_id, weight }]
export async function saveAssetWeights(weights) {
  const url = `${backendUrl}/api/widgets/user-assets/weights/`;
  const response = await fetchWithAuth(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ weights }),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.detail || `Не удалось сохранить доли: HTTP ${response.status}`);
  }
  return response.json();
}
